import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { COLORS3, FONT } from '@zola/zola-ui/src/styles/emotion';

type AnnouncementBannerProps = {
  backgroundColor?: string;
  hideContentOnScroll?: boolean;
};

export const AnnouncementBannerWrapper = styled.div<AnnouncementBannerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor !== undefined ? backgroundColor : COLORS3.COVE_100} !important;
  color: ${COLORS3.WHITE_100};
  overflow: hidden;
  height: ${({ hideContentOnScroll }) => (hideContentOnScroll ? '0' : '36px')};
  transition: height 0.3s linear;
`;

type BannerTextProps = {
  color?: string;
};

export const BannerText = styled(LinkV2)<BannerTextProps>`
  text-align: center;
  color: ${({ color }) => (color !== undefined ? color : COLORS3.SKY_100)} !important;
  &:hover,
  &:active,
  &:focus {
    color: ${({ color }) => (color !== undefined ? color : COLORS3.SKY_100)} !important;
  }

  sup {
    top: -0.5em;
  }

  sub {
    bottom: -0.25em;
  }

  sub,
  sup {
    font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
    position: relative;
  }
`;
